import { AxiosResponse } from 'axios'
import { ApiResponse, IApiErrorResponse } from '../types'

export const formatResponse = (response: AxiosResponse | IApiErrorResponse): ApiResponse =>
  isHandledErrorResponse(response)
    ? response
    : {
        statusCode: response.status,
        data: response.data,
        headers: response.headers as ApiResponse['headers'],
      }

const isHandledErrorResponse = (
  response: AxiosResponse | IApiErrorResponse,
): response is IApiErrorResponse => 'problem' in response
